
import TokenWrappedPreviewPage from './tokenwrappedpreviewpage'

export default TokenWrappedPreviewPage;